import { pattern, string } from 'superstruct'

export const AppId = pattern(string(), /^[\w-]+$/u)

export const Country = pattern(string(), /\w{2}/u)

export const Currency = pattern(string(), /\w{3}/u)

export const Asset = pattern(string(), /\w+$/u)
